import * as Yup from "yup";

/***************************************************************
 * 契約一覧
 **************************************************************/
/**
 * 契約情報一覧取得API リクエスト
 */
export class ContractSearchRequest {
  /** 公開コード */
  public disclosureCode: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 検索日時 */
  public searchDate: string = "";
  /** 検索日時モード
  * 0: 指定日に契約が有効 
  * 1: 指定日に契約開始
  * 2: 指定日に契約終了
  * 3: 指定日±7日間に契約開始
  * 4: 指定日±7日間に契約終了
  */
  public searchDateMode: string = "";
}
/**
 * 契約情報一覧取得API レスポンス
 */
export class ContractSearchResponse {
  /** 契約ID */
  public id: string = "";
  /** 公開コード */
  public disclosureCode: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 組織名 */
  public organizationName: string = "";
  /** 契約台数 */
  public contractDevice: string = "";
  /** 契約人数 */
  public contractPeople: string = "";
  /** 契約価格 */
  public contractPrice: string = "";
  /** 契約日時（開始日） */
  public contractStart: string = "";
  /** 契約日時（終了日） */
  public contractEnd: string = "";
}

/***************************************************************
 * 契約情報新規追加
 **************************************************************/
/**
 * エラーメッセージ
 */
export const ERR_MESSAGE = {
  tenantIdIsNull: "テナントを選択してください。",
  startViewIsNull: "契約期間（開始日）を選択してください。",
  contractDeviceIsNull: "契約台数を入力してください。",
  contractPeopleIsNull: "契約人数を入力してください。",
  contractPriceIsNull: "契約価格を入力してください。"
};

/**
 * バリデーションルール
 */
export const ContractCreateFormSchema = Yup.object({
  tenantId: Yup.string().required(ERR_MESSAGE.tenantIdIsNull),
  startView: Yup.date().required(ERR_MESSAGE.startViewIsNull),
  contractDevice: Yup.string().required(ERR_MESSAGE.contractDeviceIsNull),
  contractPeople: Yup.string().required(ERR_MESSAGE.contractPeopleIsNull),
  contractPrice: Yup.string().required(ERR_MESSAGE.contractPriceIsNull),
});
export const ContractEditFormSchema = Yup.object({
  tenantId: Yup.string().required(ERR_MESSAGE.tenantIdIsNull),
  startView: Yup.date().required(ERR_MESSAGE.startViewIsNull),
  contractDevice: Yup.string().required(ERR_MESSAGE.contractDeviceIsNull),
  contractPeople: Yup.string().required(ERR_MESSAGE.contractPeopleIsNull),
  contractPrice: Yup.string().required(ERR_MESSAGE.contractPriceIsNull),
});
/**
 * 契約情報新規作成・編集フォーム(入力チェック用)
 */
export class ContractEditForm {
  /** 契約情報ID */
  public id: string = "";
  /** 公開コード */
  public disclosureCode: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 契約期間（開始日） */
  public contractStart: string = "";
  /** 契約期間（終了日） */
  public contractEnd: string = "";
  /** 契約期間（開始日） */
  public startView: Date = new Date();
  /** 契約期間（終了日） */
  public endView: Date = new Date();
  /** 契約台数 */
  public contractDevice: string = "";
  /** 契約人数 */
  public contractPeople: string = "";
  /** ステータス */
  public status: string = "";
  /** トライアル */
  public trial: string = "";
  /** 端末登録料 */
  public entryPrice: string = "";
  /** 月額利用料 */
  public contractPrice: string = "";
  /** 組織ID */
  public organizationId: string = "";
  /** 組織名 */
  public organizationName: string = "";
  /** お客様管理者氏名1 */
  public adminUserName1: string = "";
  /** お客様管理者氏名2 */
  public adminUserName2: string = "";
  /** 営業担当者ID */
  public salesStaffId: string = "";
  /** 営業担当者名 */
  public salesStaffName: string = "";
  /** 備考1 */
  public comment1: string = "";
  /** 備考2 */
  public comment2: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";

}
/**
 * 契約情報新規作成リクエスト
 */
export class ContractCreateRequest {
  createdata: ContractEditForm = new ContractEditForm();
}
/**
 * テナント情報編集リクエスト
 */
export class ContractEditRequest {
  editdata: ContractEditForm = new ContractEditForm();
}

/***************************************************************
 * 契約情報詳細
 **************************************************************/
/**
 * 契約情報詳細取得API リクエスト
 */
export class ContractDetailRequest {
  /** 契約情報ID */
  public id: string = "";
}

/**
 * 契約情報詳細取得API レスポンス
 */
export class ContractDetailResponse {
  /** 契約情報ID */
  public id: string = "";
  /** 公開コード */
  public disclosureCode: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** テナント名 */
  public tenantName: string = "";
  /** 企業名 */
  public companyName: string = "";
  /** 契約期間（開始日） */
  public contractStart: string = "";
  /** 契約期間（終了日） */
  public contractEnd: string = "";
  /** 契約期間（開始日） */
  public startView: Date = new Date();
  /** 契約期間（終了日） */
  public endView: Date = new Date();
  /** 契約台数 */
  public contractDevice: string = "";
  /** 契約人数 */
  public contractPeople: string = "";
  /** ステータス */
  public status: string = "";
  /** トライアル */
  public trial: string = "";
  /** 端末登録料 */
  public entryPrice: string = "";
  /** 月額利用料 */
  public contractPrice: string = "";
  /** 組織ID */
  public organizationId: string = "";
  /** 組織名 */
  public organizationName: string = "";
  /** お客様管理者氏名1 */
  public adminUserName1: string = "";
  /** お客様管理者氏名2 */
  public adminUserName2: string = "";
  /** 営業担当者ID */
  public salesStaffId: string = "";
  /** 営業担当者名 */
  public salesStaffName: string = "";
  /** 備考1 */
  public comment1: string = "";
  /** 備考2 */
  public comment2: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
}

